module.exports = __webpack_public_path__ + "img/status-support.9754d76b.png";